import { openPreferenceCenter } from '@mentimeter/onetrust';
import { useTranslations } from 'next-intl';
import { getMentiAcademyURL } from '@mentimeter/user';
import type { FooterItem } from '../types';

// NB Remember to update static 404 page as well.
const ONETRUST_DOMAIN_SCRIPT = process.env.NEXT_PUBLIC_ONETRUST_DOMAIN_SCRIPT;

export const useDefaultFooterItems = (): FooterItem[] => {
  const t = useTranslations('first_impression.legacy.common');

  const items: FooterItem[] = [
    {
      heading: t('page_links.features'),
      links: [
        {
          children: t('page_links.overview'),
          href: '/features',
        },
        {
          children: t('page_links.ai_builder'),
          href: '/features/ai-builder',
        },
        {
          children: t('page_links.live_polling'),
          href: '/features/live-polling',
        },
        {
          children: t('page_links.word_cloud'),
          href: '/features/word-cloud',
        },
        {
          children: t('page_links.quiz'),
          href: '/features/quiz-presentations',
        },
        {
          children: t('page_links.q&a'),
          href: '/features/live-questions-and-answers',
        },
        {
          children: t('page_links.surveys'),
          href: '/features/surveys',
        },
        {
          children: t('page_links.presentation_maker'),
          href: '/features/presentation-maker',
        },
      ],
    },
    {
      heading: t('page_links.resources'),
      links: [
        {
          children: t('page_links.blog'),
          href: '/blog',
        },
        {
          children: t('page_links.how_to'),
          href: '/how-to',
        },
        {
          children: t('page_links.work'),
          href: '/work',
        },
        {
          children: t('page_links.education'),
          href: '/education',
        },
        {
          children: t('page_links.templates'),
          href: '/templates',
        },
        {
          children: 'Academy',
          href: getMentiAcademyURL(
            '?utm_source=mentimeter.com&utm_medium=referral&utm_campaign=footer',
          ),
          target: '_blank',
          prefetch: false,
          rel: 'noopener noreferrer',
        },
        {
          children: t('page_links.webinars'),
          href: '/webinars',
        },
        {
          children: t('page_links.comparison'),
          href: '/comparison',
        },
        {
          children: t('page_links.stories'),
          href: '/stories',
        },
        {
          children: t('page_links.integrations'),
          href: '/integrations',
        },
      ],
    },
    {
      heading: t('page_links.details'),
      links: [
        {
          children: t('page_links.legal'),
          href: '/trust',
        },
        {
          children: t('page_links.policies'),
          href: '/trust/legal/privacy-policy',
        },
        {
          children: t('page_links.accessibility'),
          href: '/accessibility',
        },
        {
          children: t('page_links.help_center'),
          href: 'https://help.mentimeter.com/',
          target: '_blank',
          prefetch: false,
          rel: 'noopener noreferrer',
        },
        {
          children: t('page_links.requirements'),
          href: '/requirements',
        },
        {
          children: t('page_links.ai_at_mentimeter'),
          href: '/ai-at-mentimeter',
        },
      ],
    },
    {
      heading: t('page_links.about_us'),
      links: [
        {
          children: t('page_links.press_info'),
          href: '/press',
        },
        {
          children: t('page_links.the_team'),
          href: '/the-team',
        },
        {
          children: t('page_links.jobs'),
          href: '/jobs',
        },
        {
          children: t('page_links.culture'),
          href: '/culture',
        },
        {
          children: t('page_links.benefits'),
          href: '/benefits',
        },
        {
          children: t('page_links.contact_us'),
          href: '/contact',
        },
        {
          children: t('page_links.climate'),
          href: '/climate',
        },
        {
          children: t('page_links.investors'),
          href: '/investors',
        },
      ],
    },
  ];

  if (ONETRUST_DOMAIN_SCRIPT) {
    items[2]?.links.push({
      children: t('page_links.open_cookie_preferences'),
      onClick: openPreferenceCenter,
    });
  }

  return items;
};
